import axios from "axios";

// Prefer the build-time backend URL. But when the app is served from a
// DIFFERENT host than that URL (e.g. a custom domain like kinkvault.online),
// call the current origin instead so every request stays same-origin and
// avoids credentialed cross-origin (CORS) failures. The backend is always
// co-served under /api on the same domain in every Emergent environment.
const CONFIGURED_URL = process.env.REACT_APP_BACKEND_URL || "";

function resolveBackendUrl() {
  if (typeof window === "undefined") return CONFIGURED_URL;
  try {
    const configuredOrigin = CONFIGURED_URL ? new URL(CONFIGURED_URL).origin : "";
    if (!configuredOrigin || configuredOrigin === window.location.origin) {
      return CONFIGURED_URL || window.location.origin;
    }
    // Served from a custom domain / different host -> use same origin.
    return window.location.origin;
  } catch {
    return CONFIGURED_URL || window.location.origin;
  }
}

const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("kv_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const mediaSrc = (url) => (url ? (url.startsWith("http") ? url : `${BACKEND_URL}${url}`) : "");

const _prefetched = new Map();
const _prefRelated = new Map();
export const prefetchMedia = (id, imgUrl) => {
  if (!id || _prefetched.has(id)) return;
  _prefetched.set(id, api.get(`/media/${id}`).then((r) => {
    const d = r.data;
    if (d?.media_type === "image" && d.url) { const im = new Image(); im.src = mediaSrc(d.url); }
    return d;
  }).catch(() => { _prefetched.delete(id); return null; }));
  _prefRelated.set(id, api.get(`/media/${id}/related`, { params: { limit: 12 } }).then((r) => r.data).catch(() => { _prefRelated.delete(id); return null; }));
  if (imgUrl) { const im = new Image(); im.src = mediaSrc(imgUrl); }
  if (_prefetched.size > 200) { const k = _prefetched.keys().next().value; _prefetched.delete(k); _prefRelated.delete(k); }
};
export const takePrefetchedRelated = (id) => {
  const p = _prefRelated.get(id);
  _prefRelated.delete(id);
  return p;
};
export const takePrefetched = (id) => {
  const p = _prefetched.get(id);
  _prefetched.delete(id);
  return p;
};

export const avatarSrc = (url) => {
  if (!url) return "";
  return url.startsWith("http") ? url : `${BACKEND_URL}${url}`;
};

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
